"use strict";
var Observable_1 = require('../../Observable');
var takeWhile_1 = require('../../operator/takeWhile');
Observable_1.Observable.prototype.takeWhile = takeWhile_1.takeWhile;
//# sourceMappingURL=takeWhile.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/takeWhile.js
 ** module id = 626
 ** module chunks = 3
 **/